
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    size: {
      type: Number,
      default: 20
    },
    name: {
      type: String,
      default: 'ETH'
    }
  },
  setup(props) {
    return {
      name: props.name,
      size: props.size
    }
  },
})
